import React from "react";
import styles from "./preloader.scss";

class PreLoader extends React.Component {
  show() {
    $(this.refs.container).fadeIn(300);
  }
  hide() {
    $(this.refs.container).fadeOut(300);
  }
	render()
	{
		var classes = "loader-inner ball-grid-pulse " + this.props.classes;
		return (
			<div id={this.props.id} className={classes} ref="container" style={{display: "none"}}>
				<div></div>
				<div></div>
				<div></div>
				<div></div>
				<div></div>
				<div></div>
				<div></div>
				<div></div>
				<div></div>
			</div>
		)
	}
}

export default PreLoader;


// WEBPACK FOOTER //
// ./src/components/common/preloader.jsx